const DEFAULT_TEXT_STYLE = {
    color: "#FFFFFF",
    outlineColor: "#09246f",
};

const ROUTE_TEXT_STYLES = {
    kh: {
        color: "#D33B0A",
        outlineColor: "#FFFFFF",
    },
    sc: {
        color: "#304D4E",
        outlineColor: "#FFFFFF",
    },
    leap: {
        color: "#FA0000",
        outlineColor: "#FFF832",
    },
    kp: {
        color: "#FFFFFF",
        outlineColor: "#09246F",
    },
    mt: {
        color: "#FFFFFF",
        outlineColor: "#600DA4",
    },
    mc: {
        color: "#FFFFFF",
        outlineColor: "#9C0000",
    },
    tc: {
        color: "#FFFFFF",
        outlineColor: "#1B5A7A",
    },
    tc_minhngoc: {
        color: "#FFFFFF",
        outlineColor: "#1B5A7A",
    },
};

export function getLiveTextStyle(routeType) {
    const route = String(routeType ?? "")
        .trim()
        .toLowerCase();

    return ROUTE_TEXT_STYLES[route] ?? DEFAULT_TEXT_STYLE;
}
